<template>

    <div class="search-by-machine" id="search-by-machine">


      <h2 class="categories-wrapper-title " :class="{'brand-color':!isPhone}">{{ $t("by_market_filter") }}</h2>
      <b-field>
        <b-select class="is-full" v-model="marketSelected" @change.native="$root.$emit('change-market-filter',marketSelected)"  rounded>
          <option
              v-for="market in markets"
              :value="market"
              :key="market.code"
          >
            {{ market.label }}
          </option>
        </b-select>
      </b-field>
    </div>

</template>

<script>
import {mapState} from "vuex";

export default {
name: "MarketFilter",


  data() {
    return {
      marketSelected: null,
    };
  },

  computed: {
    ...mapState({
      markets: state => state.settings.markets,
      isPhone: state => state.settings.isPhone,
    }),
  },

  created() {


  },

  methods: {
  }
}
</script>

<style scoped>
.search-by-machine {
  border-bottom: dashed 1px lightgrey;
  padding:0 25px 25px;
  margin:0 -25px 25px;
}

/deep/.select {
  width:100%;
}
</style>